import React, { useEffect } from 'react';
import useQueryParams from 'hooks/useQueryParams';
import ninjaApi from 'store/redux/apis';
import { Spin } from 'antd';
import Alert from 'components/Dialogs/Alert';
import CampaignSpent from 'components/CampaignSpent';
import { useCampaignSpentSaveMutation } from 'modules/network-accounts/api/campaign-spent.api';
import DisconnectButton from 'modules/apps/components/DisconnectButton';

const IntegrationCampaignSpent = () => {
  const { searchParams } = useQueryParams();
  const { store_id, integration_type } = searchParams;
  const [getIntegrationListQuery, { data: integration = {}, isLoading: storeLoading }] =
    ninjaApi.useLazyIntegrationListQuery();
  const [saveCampaignSpent, { isLoading }] = useCampaignSpentSaveMutation();
  const [getCampaignSpentQuery, { data }] = ninjaApi.useLazyCampaignSpentListQuery();

  useEffect(() => {
    const ids = store_id !== 'all' ? store_id.split(',').map((id) => parseInt(id, 10)) : [];

    if (store_id === 'all') {
      getIntegrationListQuery({ integration: integration_type }).unwrap();
    } else {
      getIntegrationListQuery({ integration_ids: ids }).unwrap();
    }
  }, [integration_type]);

  return (
    <div className='grid gap-4 mt-4'>
      <Alert
        type='warning'
        description='Any new campaigns added in the future will be automatically included unless manually excluded'
      />

      {storeLoading ? (
        <Spin />
      ) : (
        integration?.data?.map((store) => {
          return (
            <CampaignSpent
              extraAction={
                <DisconnectButton
                  onClick={(e) => e.stopPropagation()}
                  size='small'
                  id={store.id}
                  integration={store.type}
                  name={store.name}
                />
              }
              isLoading={storeLoading || isLoading}
              campaignSpentSave={saveCampaignSpent}
              getCampaignSpentQuery={getCampaignSpentQuery}
              store={store}
              data={data}
              params='integration_id'
            />
          );
        })
      )}
    </div>
  );
};

export default IntegrationCampaignSpent;
